import { render, staticRenderFns } from "./AgentMergeTool.vue?vue&type=template&id=0b926836&scoped=true"
import script from "./AgentMergeTool.vue?vue&type=script&lang=js"
export * from "./AgentMergeTool.vue?vue&type=script&lang=js"
import style0 from "./AgentMergeTool.vue?vue&type=style&index=0&id=0b926836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b926836",
  null
  
)

export default component.exports